import { render, staticRenderFns } from "./RequestLm.vue?vue&type=template&id=6fac53f0"
import script from "./RequestLm.vue?vue&type=script&lang=js"
export * from "./RequestLm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports